import React from "react";
import { Link } from "react-router-dom";
import {
    Collapse,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from "@mui/material";

import ThisTheme from "../../../themes/CentricTheme";

import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";

const CENTMenu = () => {
    const [open, setOpen] = React.useState(false);
    const handleClick = () => {
        setOpen(!open);
    };

    const menuItems = [
        {
            path: "/calendar",
            label: "Calendar",
            icon: (
                <CalendarMonthIcon
                    sx={{ color: ThisTheme.palette.primary.main }}
                />
            ),
        },
        {
            path: "/messages",
            label: "Messages",
            icon: (
                <EmailOutlinedIcon
                    sx={{ color: ThisTheme.palette.primary.main }}
                />
            ),
        },
        {
            path: "/tasks",
            label: "Tasks",
            icon: (
                <TaskOutlinedIcon
                    sx={{ color: ThisTheme.palette.primary.main }}
                />
            ),
        },
    ];

    return (
        <List
            component="nav"
            className="menu-list"
            aria-label="Organiser menu"
            data-cy="menu_cent"
        >
            <ListItem
                component="div"
                onClick={handleClick}
                aria-expanded={open}
                disablePadding
            >
                <ListItemButton>
                    <ListItemIcon>
                        <WorkOutlineOutlinedIcon
                            sx={{ color: ThisTheme.palette.primary.main }}
                        />
                    </ListItemIcon>
                    <ListItemText primary="Organiser" />
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItemButton>
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="nav">
                    {menuItems &&
                        menuItems.length &&
                        menuItems.map(({ path, icon, label }) => (
                            <ListItem
                                key={path}
                                component={Link}
                                to={path}
                                disablePadding
                            >
                                <ListItemButton className="nested">
                                    <ListItemIcon>{icon}</ListItemIcon>
                                    <ListItemText>{label}</ListItemText>
                                </ListItemButton>
                            </ListItem>
                        ))}
                </List>
            </Collapse>
        </List>
    );
};

export default CENTMenu;
